import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

enum adminPaths {
    ADMIN = "/admin",
    DETAIL = "/detail",
    SEARCH = "/search",
}

export const AdminRoutes = {
    Admin: adminPaths.ADMIN,
    SEARCH_MOBILE: `${adminPaths.ADMIN}${adminPaths.SEARCH}`,
    DETAIL_MOBILE: `${adminPaths.ADMIN}${adminPaths.DETAIL}`,
} as const;

export const adminRoutes = (
    <Route
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { AdminModuleLayout } =
                await import("@admin/presentation/layout/admin-module.layout.tsx");
            return { Component: AdminModuleLayout };
        }}
    >
        <Route
            path={AdminRoutes.Admin}
            lazy={async () => {
                const { AdminResponsivePage } =
                    await import("@admin/presentation/pages/admin/admin-responsive.page.tsx");
                return { Component: AdminResponsivePage };
            }}
        />
        <Route
            path={AdminRoutes.DETAIL_MOBILE}
            lazy={async () => {
                const { AdminStationDetailMobilePage } =
                    await import("@admin/presentation/pages/admin/mobile/detail/admin-station-detail-mobile.page.tsx");
                return {
                    Component: AdminStationDetailMobilePage,
                };
            }}
        />
        <Route
            path={AdminRoutes.SEARCH_MOBILE}
            lazy={async () => {
                const { AdminStationSearchMobilePage } =
                    await import("@admin/presentation/pages/admin/mobile/search/admin-station-search-mobile.page");
                return {
                    Component: AdminStationSearchMobilePage,
                };
            }}
        />
    </Route>
);
